import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import isEmpty from "lodash/isEmpty";

/*---------------------------------------------------------------------------*/

function resetDataSaved() {
  return actions.resetDataSaved();
}

/*---------------------------------------------------------------------------*/

function attachListenersTareasDeVenta(idColegio = null) {
  return isEmpty(idColegio)
    ? null
    : dispatch => {
        dispatch(attachOnAddedTareasDeVenta(idColegio));
        dispatch(attachOnRemovedTareasDeVenta(idColegio));
        dispatch(attachOnChangedTareasDeVenta(idColegio));
      };
}

function attachOnAddedTareasDeVenta(idColegio) {
  return dispatch =>
    rootRef
      .child("ventas/tareas_de_venta")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .on(
        "child_added",
        snap =>
          snap.hasChildren() && dispatch(actions.addedTareaDeVenta(snap.val()))
      );
}

function attachOnRemovedTareasDeVenta(idColegio) {
  return dispatch =>
    rootRef
      .child("ventas/tareas_de_venta")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .on(
        "child_removed",
        snap =>
          snap.hasChildren() &&
          dispatch(actions.removedTareaDeVenta(snap.val()))
      );
}

function attachOnChangedTareasDeVenta(idColegio) {
  return dispatch =>
    rootRef
      .child("ventas/tareas_de_venta")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .on(
        "child_changed",
        snap =>
          snap.hasChildren() &&
          dispatch(actions.changedTareaDeVenta(snap.val()))
      );
}

/*---------------------------------------------------------------------------*/

function detachListenersTareasDeVenta() {
  return dispatch => {
    rootRef.child("ventas/tareas_de_venta").off("child_added");
    rootRef.child("ventas/tareas_de_venta").off("child_removed");
    rootRef.child("ventas/tareas_de_venta").off("child_changed");
  };
}

/*---------------------------------------------------------------------------*/

function limpiarTareasDeVenta() {
  return actions.limpiarTareasDeVenta();
}

/*---------------------------------------------------------------------------*/

function addNuevaTareaDeVenta(datos) {
  return dispatch => {
    const ruta = "ventas/tareas_de_venta";
    const id = datos.isEdit ? datos.id : rootRef.child(ruta).push().key;
    const timestamp = datos.isEdit ? datos.timestamp : new Date().getTime();

    delete datos.isEdit;

    let insert = {};
    insert[`${ruta}/${id}`] = { ...datos, id, timestamp };
    rootRef.update(insert, () =>
      dispatch(
        actions.saveData({
          status: true,
          msg: "Contacto insertado"
        })
      )
    );
  };
}

function borrarTareaDeVenta({ idTarea }) {
  return dispatch =>
    rootRef.child(`ventas/tareas_de_venta/${idTarea}`).remove();
}

function completarTareaDeVenta({ idTarea }) {
  return dispatch => {
    let insert = {};
    insert[`ventas/tareas_de_venta/${idTarea}/completada`] = true;
    rootRef.update(insert);
  };
}
/*---------------------------------------------------------------------------*/

export {
  attachListenersTareasDeVenta,
  resetDataSaved,
  detachListenersTareasDeVenta,
  limpiarTareasDeVenta,
  addNuevaTareaDeVenta,
  borrarTareaDeVenta,
  completarTareaDeVenta
};



// WEBPACK FOOTER //
// ./src/ducks/ventasTareas/operations.js